// extracted by mini-css-extract-plugin
export var container = "GuidesAndResources-module--container--CMF2t";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var resource = "GuidesAndResources-module--resource--CDUPK";
export var row = "GuidesAndResources-module--row--CQX2-";
export var sectionContainer = "GuidesAndResources-module--sectionContainer--bJgPN";
export var title = "GuidesAndResources-module--title--iUWrl";